var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.customerTrailList.length
      ? _c("p", { staticClass: "no_data" }, [_vm._v("暂无数据~")])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "timeline_box" },
      [
        _c(
          "a-timeline",
          { staticClass: "timeline_left", attrs: { mode: "right" } },
          _vm._l(_vm.customerTrailList, function (item, index) {
            return _c(
              "a-timeline-item",
              { key: index, staticClass: "line_item", attrs: { color: "red" } },
              [
                _c("span", { staticClass: "time" }, [
                  _vm._v(_vm._s(item.trajectoryDate)),
                ]),
              ]
            )
          }),
          1
        ),
        _c(
          "a-timeline",
          { staticClass: "timeline_right" },
          _vm._l(_vm.customerTrailList, function (item, index) {
            return _c(
              "a-timeline-item",
              {
                key: index,
                staticClass: "line_item fix",
                attrs: { color: "red" },
              },
              [
                _c("div", { staticClass: "things_box l" }, [
                  _c("span", { staticClass: "words_item" }, [
                    _vm._v(_vm._s(item.trajectoryContent)),
                  ]),
                  item.stayLength
                    ? _c("span", { staticClass: "label_item" }, [
                        _vm._v("停留时长 " + _vm._s(item.stayLength) + " s"),
                      ])
                    : _vm._e(),
                  item.browseProgress
                    ? _c("span", { staticClass: "label_item" }, [
                        _vm._v("进度 " + _vm._s(item.browseProgress) + " %"),
                      ])
                    : _vm._e(),
                ]),
              ]
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }